import { valueOf } from "@/types/common";

export const SORTING = {
  ASC: "ASC",
  DESC: "DESC",
};

export type TSorting = valueOf<typeof SORTING>;
